import { useIdStore, useViewedTypeStore } from "../stores/selectedToViewStore";
import { useContacts } from "./crm/useContacts";

import { useFamilies } from "./crm/useFamilies";

/**
 * מחזיר את שם המשתמש או המשפחה שנבחרו לתצוגה, לפי ה־store
 */
export const useViewedEntityName = (): string => {
  const id = useIdStore((state) => state.id);
  const viewedType = useViewedTypeStore((state) => state.viewedType);

  const { data: contacts } = useContacts();
  const { data: families } = useFamilies();

  if (viewedType === "USER") {
    const contact = contacts?.find((c) => c.id === id);
    return contact
      ? `${contact.first_name ?? ""} ${contact.last_name ?? ""}`.trim()
      : "";
  }

  if (viewedType === "FAMILY") {
    const family = families?.find((f) => f.id === id);
    return family?.name || "";
  }

  return "";
};
